var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22667_113157)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0026 34.8333C30.0026 38.055 32.6143 40.6667 35.8359 40.6667C39.0576 40.6667 41.6693 38.055 41.6693 34.8333C41.6693 31.6117 39.0576 29 35.8359 29C32.6143 29 30.0026 31.6117 30.0026 34.8333ZM30.0026 34.8333C30.0026 33.5199 30.4367 32.3078 31.1693 31.3328V20.8333M30.0026 34.8333C30.0026 35.7962 30.2359 36.7047 30.6491 37.5051C29.6662 38.3354 27.3961 38.9167 24.7526 38.9167C21.2088 38.9167 18.3359 37.872 18.3359 36.5833V20.8333M31.1693 20.8333C31.1693 22.122 28.2964 23.1667 24.7526 23.1667C21.2088 23.1667 18.3359 22.122 18.3359 20.8333M31.1693 20.8333C31.1693 19.5447 28.2964 18.5 24.7526 18.5C21.2088 18.5 18.3359 19.5447 18.3359 20.8333M18.3359 31.3333C18.3359 32.622 21.2088 33.6667 24.7526 33.6667C27.3064 33.6667 29.5118 33.1241 30.5447 32.3387M31.1693 26.0833C31.1693 27.372 28.2964 28.4167 24.7526 28.4167C21.2088 28.4167 18.3359 27.372 18.3359 26.0833",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22667_113157",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22667_113157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22667_113157",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyBadge);
export default __webpack_public_path__ + "static/media/loyalty-badge.a834db4ca8414d606ce20cf8d249e2c6.svg";
export { ForwardRef as ReactComponent };